import { render, staticRenderFns } from "./help.vue?vue&type=template&id=2c8448ef&scoped=true"
var script = {}
import style0 from "./help.vue?vue&type=style&index=0&id=2c8448ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8448ef",
  null
  
)

export default component.exports